import { Modal, Image, Button } from '@codeparva/ui-components-library';
import React, { useState, useEffect } from 'react';
import { CPImage } from '../../components/imageWrapper/CPImage';
import { FontAwesomeIcon } from '../../utilities/iconLoader/FontAwesomeIcon';
import { weakKey } from '../../utilities/weakKey';
import { threeImageButton, thumbnail } from './constants';
import { GalleryTypes } from './GalleryTypes';
import useWindowProperty from '../../utilities/useWindowProperty';

export const Gallery = ({
  media,
  maxWidth,
  type,
  variant,
}: GalleryTypes.IGallery) => {
  const isBrowser = typeof window !== 'undefined';
  const doc: any = isBrowser ? window.document : null;
  const [openModal, setOpenModal] = useState<string>('');
  const [count, setCount] = useState(0);
  const [imageCount, setImageCount] = useState(0);
  const [showModal, onShowModal] = useState(false);
  const [scrollYPixels, setScrollYPixels] = useState(0);
  const [close, setClose] = useState(false);
  const scrollYWindowPixels = useWindowProperty('scrollY');
  useEffect(() => {
    setImageCount(media.length - 3);
    setScrollYPixels(typeof window !== 'undefined' ? scrollYWindowPixels : 0);
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollYPixels}px`;
    } else {
      if (close) {
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        typeof window !== 'undefined'
          ? window.scrollTo(0, parseInt(scrollY || '0') * -1)
          : null;
        setClose(false);
      }
    }
  }, [imageCount, showModal, scrollYWindowPixels]);

  const onOpenModal = () => {
    onShowModal(!showModal);
    return setOpenModal('card');
  };

  const onCloseClicked = () => {
    setClose(true);
    onShowModal(!showModal);
    return setOpenModal('');
  };
  const renderThumbnails = () =>
    media &&
    media.slice(0, 3).map((imagesSrc: any, index: number) => (
      <div className="m-1 galleryThumbnail">
        <Image
          src={imagesSrc.imageUrl}
          alt={imagesSrc.alt}
          onClick={onOpenModal}
          className={index === 2 ? 'makeAbsolute' : ''}
        />
        {index === 2 && (
          <div onClick={onOpenModal} className="imageCount">
            + {imageCount}
          </div>
        )}
      </div>
    ));

  const renderImageWithButton = () => {
    const image = media && media[0];
    return (
      <div className="is-flex is-flex-direction-column is-align-items-center">
        <Image
          src={image.imageUrl}
          alt={image.alt}
          onClick={onOpenModal}
          className="mb-4"
        />
        <Button onClick={onOpenModal} className="CustomButton">
          {' '}
          View All Images
        </Button>
      </div>
    );
  };
  const renderThreeImageWithButton = () => {
    return (
      <div className="threeImageSection">
        <div className="is-flex is-flex-direction-row">
          {media &&
            media.slice(0, 3).map((image: any, index: any) => (
              <div className="threeImageContainer" key={weakKey({ image })}>
                {' '}
                <div className="m-1 galleryThumbnail">
                  <Image
                    src={image.imageUrl}
                    alt={image.alt}
                    onClick={onOpenModal}
                    className={index === 2 ? 'makeAbsolute' : ''}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="buttonContainer pt-4">
          <Button onClick={onOpenModal} className="CustomButton button">
            {' '}
            View All Images
          </Button>
        </div>
      </div>
    );
  };
  const renderVariant = (variant: any) => {
    if (variant === thumbnail) {
      return renderThumbnails();
    } else if (variant === threeImageButton) {
      return renderThreeImageWithButton();
    } else {
      return renderImageWithButton();
    }
  };

  return (
    <div
      className={`galleryComponent  ${type === 'horizontal' ? 'is-flex' : ''}`}
    >
      {renderVariant(variant)}
      <Modal
        show={openModal === 'card'}
        onClose={onCloseClicked}
        document={doc}
        closeOnEsc
        closeOnBlur
        showClose
        className="is-flex is-flex-direction-row"
      >
        <div className="is-flex is-align-items-center">
          {count > 0 && (
            <Button onClick={() => setCount(count - 1)} disabled={count <= 0}>
              <FontAwesomeIcon iconClassName="FaAngleLeft" />
            </Button>
          )}
          {media &&
            media.map((imagesSrc: any, index: number) => (
              <div key={weakKey(imagesSrc)}>
                {imagesSrc.gatsbyImageData ? (
                  count === index && (
                    <Modal.Card className="is-align-items-center">
                      <CPImage gatsbyImageData={imagesSrc.gatsbyImageData} />
                    </Modal.Card>
                  )
                ) : (
                  <Image
                    src={imagesSrc.imageUrl}
                    alt={imagesSrc.alt}
                    size={maxWidth}
                    fullwidth={maxWidth === 'full-size'}
                    style={{
                      maxWidth: maxWidth !== 'full-size' ? maxWidth : undefined,
                    }}
                  />
                )}
              </div>
            ))}
          {count < media.length - 1 && (
            <Button onClick={() => setCount(count + 1)}>
              <FontAwesomeIcon iconClassName="FaAngleRight" />
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
};
